import {
  ChangeDetectionStrategy,
  Component,
  Input,
  computed,
  inject,
  signal,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Company } from '../../model/company.model';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-company-badge',
  templateUrl: './company-badge.component.html',
  styleUrl: './company-badge.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip],
})
export class CompanyBadgeComponent {
  private readonly companyService = inject(CompanyService);
  private readonly _abbreviation = signal<string | null | undefined>(null);

  @Input({ required: true })
  set abbreviation(value: string | null | undefined) {
    this._abbreviation.set(value);
  }

  protected readonly company = computed<Company | undefined>(() =>
    this.companyService.byAbbreviation(this._abbreviation()),
  );

  protected readonly label = computed(() => this._abbreviation() ?? '');
  protected readonly tooltip = computed(
    () => this.company()?.name ?? this._abbreviation() ?? '',
  );

  protected readonly styles = computed(() => {
    const color = this.company()?.color;
    if (!color) {
      return {
        background: 'transparent',
        color: 'inherit',
        'border-color': 'currentColor',
      };
    }
    return {
      background: `color-mix(in srgb, ${color} 12%, white)`,
      color,
      'border-color': `color-mix(in srgb, ${color} 45%, white)`,
    };
  });
}
